import { Star } from "lucide-react";

export function RatingStars({ value = 0, count = 0, showValue = true, size = 12 }) {
  if (!count) {
    return <span className="text-xs text-muted-foreground/70">New</span>;
  }
  return (
    <span className="inline-flex items-center gap-0.5" title={`${value} / 5 · ${count} rating${count > 1 ? "s" : ""}`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} style={{ width: size, height: size }}
          className={n <= Math.round(value) ? "text-amber-400 fill-amber-400" : "text-muted-foreground/30"} />
      ))}
      {showValue && <span className="text-xs text-muted-foreground font-mono-num ml-0.5">{value} ({count})</span>}
    </span>
  );
}
